const Marquee = ({ items = [] }) => {
  const doubled = [...items, ...items];
  return (
    <div data-testid="marquee" className="overflow-hidden bg-forest text-white py-5 border-y border-white/10">
      <div className="marquee-track">
        {doubled.map((it, i) => (
          <span
            key={i}
            className="font-heading italic uppercase tracking-tight text-3xl md:text-4xl font-black px-8 flex items-center gap-8 whitespace-nowrap"
          >
            {it}
            <span className="text-burnt">●</span>
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
